import { PageHeader } from "@design-system/components";
import { contactUsBreadcrumb } from "../data";
import { ContactUsLocation } from "./ContactUsLocation";

export function ContactUsHeader() {
  return (
    <PageHeader
      translationKey="contactUsPage.title"
      breadcrumbItems={contactUsBreadcrumb}
      SideComponent={ContactUsLocation}
      contentClassName="text-2xl font-light leading-[33px] opacity-80"
    />
  );
}
